import { Breadcrumbs, Button, Card, CardActions, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { FunctionComponent, useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
}))

const getYearRange = (retirementYear: number) => {
    const currentYear = new Date().getFullYear();
    const startYear = retirementYear || 2016;
    const yearList: number[] = [];
    for (let i = (startYear < currentYear - 3) ? currentYear - 3 : startYear; i <= currentYear; i++) {
        yearList.push(i);
    }
    return yearList.reverse();
}

type FormikForm = {
    year: string,
    part: string,
    file: any,
    fileName?: string,
}

type Form16PageProps = {
}

type PensionerApiData = {
    name: string,
    spouseName: string,
    pensionerAddr: string,
    dobSpouse: string,
    dtRet: string,
    categoryPensioner: string,
    lastPenMonth: string,
    pensionerType: string,
    aadharNo: string,
    panId: string,
    contactNo: string,
    emailId: string,
    bankAccNum: string,
}

type PensionerProfileState = {
    loading: boolean,
    error: string,
    profile: Array<PensionerApiData>
}

export const Form16Page: FunctionComponent<Form16PageProps> = () => {
    const classes = useStyles()
    const store = useStore()
    const [profileData, setProfile] = useState<PensionerProfileState>({ loading: true, error: '', profile: [] });

    useEffect(() => {
        fetchProfile()
    }, []);

    const fetchProfile = async () => {
        axios.get<ApiResponse<{ profile: PensionerApiData[] }>>(`api/pensioner/profile-details`, {
            headers: {
                'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}`
            }
        })
            .then(
                ({ data: resp }) => {
                    if (resp.status === "success") {
                        const profile: PensionerApiData[] = resp.data.profile;
                        setProfile({ loading: false, error: '', profile: profile })
                    } else {
                        setProfile({ loading: false, error: resp.message, profile: [] })
                    }
                },
                () => { setProfile({ loading: false, error: "Network Error", profile: [] }) }
            )
    }
    const retirementYear = (() => {
        try {
            return new Date(profileData?.profile[0]?.dtRet).getFullYear();
        }
        catch {
            return 0;
        }
    })();

    const yearRange = getYearRange(retirementYear);

    const getFiscalYear = (y: number) => `${y}-${(y + 1).toString().slice(-2)}`

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    initialValues={{
                        year: getFiscalYear(new Date().getFullYear()),
                        part: "A",
                        file: null,
                    }}
                    validate={(values) => {
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                        setSubmitting(true)
                        setFieldValue('fileName', `form16-${values.year}.pdf`)
                        setFieldValue('file', {
                            url: `${process.env.REACT_APP_API_ROOT}api/pensioner/form16/${values.year}/${values.part}`,
                            httpHeaders: { 'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}` },
                        })
                    }}
                >
                    {
                        ({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<FormikForm>) =>
                            <Form>
                                <Grid
                                    item
                                    container
                                    spacing={3}
                                    direction="column"
                                    justify="space-around"
                                    alignItems="stretch"
                                >
                                    <Grid item>
                                        <Card elevation={3}>
                                            <CardContent>
                                                <Grid container spacing={3} direction="column" justify="space-around"
                                                    alignItems="stretch">
                                                    <Grid item>
                                                        <Breadcrumbs>
                                                            <Link to="/" className={classes.link}>
                                                                <Typography gutterBottom variant="h5" component="h2">
                                                                    <HomeIcon className={classes.icon} />Home</Typography>
                                                            </Link>
                                                            <Typography gutterBottom variant="h5" component="h2">Form 16 (ফর্ম 16)</Typography>
                                                        </Breadcrumbs>
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControl variant="filled" fullWidth disabled={isSubmitting}>
                                                            <InputLabel id="demo-simple-select-filled-label">Assessment Year (মূল্যায়ন বছর)</InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-filled-label"
                                                                id="demo-simple-select-filled"
                                                                name="year"
                                                                value={values.year}
                                                                onChange={handleChange}
                                                            >
                                                                {
                                                                    yearRange.map(y => <MenuItem value={getFiscalYear(y)}>{getFiscalYear(y)}</MenuItem>)
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControl variant="filled" fullWidth disabled={isSubmitting}>
                                                            <InputLabel id="part-input">Part (অংশ)</InputLabel>
                                                            <Select
                                                                labelId="part-input"
                                                                id="part-input"
                                                                name="part"
                                                                value={values.part}
                                                                onChange={handleChange}
                                                            >
                                                                <MenuItem value={"A"}>Pension Part A (পেনশন পার্ট A)</MenuItem>
                                                                <MenuItem value={"B"}>Pension Part B (পেনশন পার্ট B)</MenuItem>
                                                                <MenuItem value={"C"}>Salary/ Arrear Part A (বকেয়া পার্ট A)</MenuItem>
                                                                <MenuItem value={"D"}>Salary/Arrear Part B (বকেয়া পার্ট B)</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <CardActions>
                                                <Button type="reset" size="large" color="primary" variant="contained" disabled={isSubmitting}>
                                                    Reset (রিসেট)
                                                </Button>
                                                <LoadingButton type="submit" size="large" color="primary" variant="contained" loading={isSubmitting}>
                                                    Load Statement (লোড স্টেটমেন্ট)
                                                </LoadingButton>

                                                <Link to="/" className={classes.link}>
                                                    <Button variant='contained' color='primary' size='large'>
                                                        Back (পিছনে)
                                                    </Button>
                                                </Link>

                                            </CardActions>
                                        </Card>
                                    </Grid>
                                    {
                                        !!values.file && !!values.fileName &&
                                        < Grid item>
                                            <Card>
                                                <CardContent>
                                                    <PdfViewer
                                                        downloadFileName={values.fileName}
                                                        file={values.file}
                                                        onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                        onDocumentLoadError={() => { setSubmitting(false) }}
                                                        error={
                                                            <>
                                                                <Typography
                                                                    variant="h6"
                                                                    component="h6"
                                                                    style={{ textAlign: "center" }}
                                                                    color="secondary">
                                                                    Form 16 not present for the chosen period/ category. Please contact Pension Cell. <br />
                                                                    <b>(সময়কাল/ শ্রেণীর জন্য ফর্ম ১৬ অনুপস্থিত। অনুগ্রহ করে পেনশন সেলের সাথে যোগাযোগ করুন।)</b>
                                                                </Typography>
                                                            </>
                                                        }
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    }
                                </Grid>
                            </Form>
                    }
                </Formik>

            </Grid>
        </AppShell >
    )
}